import { appleDRM, openDRM, DRM_TYPES } from './constants';
export function isSupportedAppleDRM(drm) {
    return appleDRM.includes(drm);
}
export function isSupportedOpenDRM(drm) {
    return openDRM.includes(drm);
}
export function getBestDRMForDash(drmInfo) {
    for (const drm of drmInfo.supportedDRM) {
        if (isSupportedOpenDRM(drm) && !drmInfo.preferredDRM) {
            return 'widevine';
        }
        if (isSupportedAppleDRM(drm) && drmInfo.preferredDRM === DRM_TYPES.FAIRPLAY) {
            return DRM_TYPES.FAIRPLAY;
        }
    }
    return '';
}
export function getBestDRMForHls(drmInfo) {
    for (const drm of drmInfo.supportedDRM) {
        if (isSupportedAppleDRM(drm) && (drmInfo.preferredDRM === DRM_TYPES.FAIRPLAY || !drmInfo.preferredDRM)) {
            return DRM_TYPES.FAIRPLAY;
        }
    }
    return '';
}
